import { IconPlayTvguide } from '@assets/icon-play-tvguide';
import type { TvChannel, TvChannelShowtime } from '@lib/graphql/generated';
import { useTvGuideStore } from '@src/stores/tvguide';
import { createDate, isCurrent } from '@utils/dateHelpers';
import { getShowtimeWatchUrl } from '@utils/showtimeWatchUrl';
import { format } from 'date-fns';
import { twMerge } from 'tailwind-merge';

export interface ColumnProgramEntryProps {
  entry: TvChannelShowtime;
  currentTime: Date;
  channel: TvChannel;
}

export const ColumnProgramEntry = ({ entry, channel, currentTime }: ColumnProgramEntryProps) => {
  const setOpenEntryData = useTvGuideStore((state) => state.setOpenEntryData);
  const dragging = useTvGuideStore((state) => state.dragging);
  const isCurrentEntry = isCurrent(entry.start, entry.stop, currentTime);
  const watchUrl = getShowtimeWatchUrl(entry, currentTime, channel);
  const baseStyle = twMerge(
    'pointer-events-auto grid justify-start text-left h-24 md:h-32 w-full min-w-0 cursor-pointer grid-rows-[1fr_auto] rounded-lg border border-gray-600 p-4 hover:border-primary',
    isCurrentEntry ? 'bg-gray-600' : 'bg-gray-700',
  );

  return (
    <button
      type="button"
      onClick={() => {
        if (dragging) return;
        setOpenEntryData(entry, channel);
      }}
      className={baseStyle}
    >
      <div className={twMerge('font-bold text-sm tracking-2px', isCurrentEntry ? 'text-primary' : 'text-gray-400')}>
        {watchUrl && (
          <span className="mr-2 inline-flex align-middle" role="img" aria-label="Auf Joyn anschauen">
            <IconPlayTvguide classProps={{ root: 'text-white' }} />
          </span>
        )}
        {format(createDate(entry.start), 'HH:mm')}&nbsp;-&nbsp;
        {format(createDate(entry.stop), 'HH:mm')}
      </div>
      <div className="hyphenate line-clamp-2 text-base leading-body">{entry.title}</div>
    </button>
  );
};
